import {createFileRoute} from '@tanstack/react-router'
import {SuccessTransaction} from "@/components/wallet/TransactionStatuses/SuccessTransaction/SuccessTransaction"

export const Route = createFileRoute('/_mainLayout/wallet/transaction-success/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SuccessTransaction/>
}
